import * as actionDefinitions from './actionDefinitions';

import { ClientsResponse } from '../../types/redux/stores/clients.types';

export const getClientsRequest = (data: any) => ({ type: actionDefinitions.GET_CLIENTS_REQUEST, data });
export const getClientsRequestFailure = (error: any) => ({ type: actionDefinitions.GET_CLIENTS_REQUEST_FAILURE, error });
export const getClientsRequestSuccess = (payload: ClientsResponse) => ({ type: actionDefinitions.GET_CLIENTS_REQUEST_SUCCESS, payload });

export const getClientsStopLoading = () => ({ type: actionDefinitions.GET_CLIENTS_STOP_LOADING });
